/** True when running inside a Capacitor native shell (store app). */
export function isNativeApp(): boolean {
  try {
    return !!(window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

/** MDT-only store / native build target. */
export function isMdtAppTarget(): boolean {
  return import.meta.env.VITE_APP_TARGET === 'mdt' || isNativeApp();
}
